import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
export default [
// The institution column exposed by extend.php's
// Extend\ApiResource(UserResource::class), shown alongside the username
// in forum/index.tsx.
new Extend.Model(User).attribute('slpInstitution')];